//@flow
export const categoriesActionTypes = {
  LOAD_CATEGORIES: "LOAD_CATEGORIES",
  SAVE_PARENT_CATEGORY: "SAVE_PARENT_CATEGORY",
  SELECT_CATEGORY: "SELECT_CATEGORY",
};

export type CategoriesActionType = $Keys<typeof categoriesActionTypes>;
